module.exports = __webpack_public_path__ + "img/grain.05eff511.svg";